import ApiModel from 'models/api-model';
import ComfortLetter from 'models/data/comfort-letter-model';
import clonedeep from 'lodash.clonedeep';

export default class ElementComfortLetterList extends ApiModel({
  data: {
    comfortLetters: [],
  },
}) {
  get comfortLetters() {
    if (this.data) {
      return this.data.comfortLetters;
    }
    return [];
  }
  processResponse({ response }) {
    return {
      data: {
        comfortLetters:
          response &&
          response.data &&
          response.data.result &&
          response.data.result.map((comfortLetter) =>
            new ComfortLetter().convertApiResponsetoComfortLetterModelFormat(
              comfortLetter,
            ),
          ),
      },
    };
  }

  getComfortLetterCount() {
    if (this.hasComfortLetter()) {
      return this.data.comfortLetters.length;
    }
    return 0;
  }

  get(index) {
    if (
      this.data &&
      this.data.comfortLetters &&
      index >= 0 &&
      index < this.data.comfortLetters.length
    ) {
      return this.data.comfortLetters[index];
    }
    return null;
  }

  hasComfortLetter() {
    return (
      this.data &&
      this.data.comfortLetters &&
      this.data.comfortLetters.length > 0
    );
  }

  getComfortLettersSortedAlphabetically() {
    if (this.data) {
      return this.data.comfortLetters.sort((b, a) =>
        b.comfortLetterCreatedDate.localeCompare(a.comfortLetterCreatedDate),
      );
    }
    return [];
  }
  updateComfortLetterInElementPanelWithSocketPayload(payload) {
    let comfortLetterCopy = [...this.data.comfortLetters];
    comfortLetterCopy.forEach((comfortLetter, idx) => {
      if (
        payload.comfortLetterId === comfortLetter.comfortLetterId &&
        comfortLetter.revisionId === payload.revisionId
      ) {
        comfortLetterCopy[idx] =
          new ComfortLetter().convertApiResponsetoComfortLetterModelFormat(
            payload,
          );
      }
    });
    return this.mergeData({
      comfortLetters: comfortLetterCopy,
    });
  }

  removeComfortLetterFromElementPanelWithSocketPayload(payload) {
    let comfortLetterCopy = [...this.data.comfortLetters];
    comfortLetterCopy = comfortLetterCopy.filter(
      (comfortLetter) =>
        comfortLetter.comfortLetterId !== payload.comfortLetterId,
    );
    return this.mergeData({
      comfortLetters: comfortLetterCopy,
    });
  }

  /** The elementId parameter is an elementId for the element for which element panel is open
   * If element panel is closed then this function will not be called.
   * NOTE :: This particular function is not for updating the particular commfort letter
   * instead it is for inserting the entire new comfort letter object into an array.
   */
  setComfortAnnotationListFromWebSocketPayload({
    webSocketPayload,
    elementId,
  }) {
    const comfortLettersCopy = clonedeep(this.data.comfortLetters);
    const comfortLettersMap = comfortLettersCopy.reduce(
      (elementMap, elementData) => {
        elementMap[elementData.comfortLetterId] = elementData;
        return elementMap;
      },
      {},
    );

    webSocketPayload.forEach((comfortLetter) => {
      /**If webSocketPayload has an update for element(opened in element panel) and
       * comfortLetterId in webSocketPayload does not already exists in list then update the list
       * with this new comfort letter data in webSocketPayload
       */
      if (
        comfortLetter.elementId === elementId &&
        !(comfortLetter.comfortLetterId in comfortLettersMap)
      ) {
        comfortLettersCopy.push(
          new ComfortLetter().convertApiResponsetoComfortLetterModelFormat(
            comfortLetter,
          ),
        );
      }
    });

    return this.mergeData({
      comfortLetters: comfortLettersCopy,
    });
  }
  removeComfortLetterWithSocketPayloadInBulk(payload) {
    let comfortLetterCopy = [...this.data.comfortLetters];
    comfortLetterCopy = comfortLetterCopy.filter(
      (comfortLetter) => !payload.has(comfortLetter.comfortLetterId),
    );
    return this.mergeData({
      comfortLetters: comfortLetterCopy,
    });
  }
}
